export default "__VITE_ASSET__BHtwJCGc__"